module.exports = __webpack_public_path__ + "img/Plus-survol.a1c0f5e8.svg";